import React from "react";

const UserAlertDismissTriggerContext = React.createContext();
export default UserAlertDismissTriggerContext;
